import React from 'react';
import { Clock, Coffee } from 'lucide-react';
import { useSwipeGesture } from '../hooks/useSwipeGesture';
import LazyImage from './LazyImage';
import { config } from '../config/environment';

interface Produto {
  id: number;
  nome: string;
  descricao: string;
  preco: number;
  imagem_url?: string;
  codigo?: string;
  tempo_preparo: number;
}

interface ProductCardProps {
  produto: Produto;
  isDestaque?: boolean;
  onSelect: () => void;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  swipeEnabled?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({
  produto,
  isDestaque = false,
  onSelect,
  onSwipeLeft,
  onSwipeRight,
  swipeEnabled = false
}) => {
  const swipeHandlers = useSwipeGesture({
    onSwipeLeft: onSwipeLeft,
    onSwipeRight: onSwipeRight,
    enabled: swipeEnabled
  });

  return (
    <div
      {...(swipeEnabled ? swipeHandlers : {})}
      className={`bg-gradient-to-br rounded-xl p-4 sm:p-5 border transition-all duration-200 cursor-pointer touch-manipulation active:scale-95 shadow-md hover:shadow-xl min-h-[100px] from-gray-700/50 to-gray-600/50 border-gray-600/30 hover:border-orange-500/50 ${
        isDestaque ? 'ring-2 ring-orange-500 ring-offset-2 ring-offset-gray-800' : ''
      }`}
      onClick={onSelect}
    >
      <div className="flex gap-3 sm:gap-4">
        {produto.imagem_url && (
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-600 rounded-lg overflow-hidden flex-shrink-0">
            <LazyImage
              src={produto.imagem_url}
              alt={produto.nome}
              className="w-full h-full object-cover"
              baseUrl={config.api.baseUrl}
            />
          </div>
        )}
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1 flex-wrap">
            <h3 className="text-base sm:text-lg font-bold text-white truncate">
              {produto.nome}
            </h3>
            {produto.codigo && (
              <span className="bg-purple-500/20 text-purple-300 text-xs px-2 py-0.5 rounded border border-purple-500/30 flex-shrink-0 font-mono">
                {produto.codigo}
              </span>
            )}
          </div>
          <p className="text-gray-400 text-xs sm:text-sm line-clamp-2">
            {produto.descricao}
          </p>
          <div className="flex items-center justify-between mt-2">
            <span className="text-orange-400 font-bold text-sm sm:text-base">
              R$ {produto.preco.toFixed(2)}
            </span>
            {produto.tempo_preparo > 0 && (
              <div className="flex items-center gap-1 sm:gap-2 text-gray-400 text-xs sm:text-sm">
                <Clock className="h-3 w-3 sm:h-4 sm:w-4" />
                {produto.tempo_preparo} min
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
